import React, { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@hooks/index';
import ConditionalRendering from '@components/common/conditional-rendering/ConditionalRendering';
import HistoricalNoticesView from '../components/HistoricalNoticesView';
import { type IHistoricalNoticesFetchRequest } from '../constants';
import { fetchMemberHistoricalNotices, resetMemberHistoricalNotices } from '@actions/individualPortal/historicalNotices/memberHistoricalNoticesActionCreators';

const HistoricalNoticesContainer: React.FC = () => {
    const dispatch = useAppDispatch();
    const { hasLoaded, notices, totalCount, pageNumber, pageSize, sortColumn, sortOrder, hasLoadError } =
        useAppSelector(state => state.individualPortal.memberHistoricalNotices);

    const handleFetch = useCallback(
        (options: Partial<IHistoricalNoticesFetchRequest>) => {
            dispatch(fetchMemberHistoricalNotices(options));
        },
        [dispatch],
    );

    useEffect(() => {
        handleFetch({});
    }, [handleFetch]);

    useEffect(() => {
        return () => {
            dispatch(resetMemberHistoricalNotices());
        };
    }, [dispatch]);

    return (
        <ConditionalRendering isTrue={hasLoaded}>
            <HistoricalNoticesView
                notices={notices}
                totalCount={totalCount}
                pageNumber={pageNumber}
                pageSize={pageSize}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                hasLoadError={hasLoadError}
                onFetch={handleFetch}
            />
        </ConditionalRendering>
    );
};

export default HistoricalNoticesContainer;
